module.exports = __webpack_public_path__ + "img/Inflammation-OVCA_10X_TIP.32eb9681.png";